import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { setToken, getToken } from "../libs/util.js";

Vue.use(VueRouter)

const routes = [
  {
    path: '/tcmr/home',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页'
    }
  },
  // {
  //   path: '/tcmr/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/tcmr/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/tcmr/module',
    name: 'module',
    component: () => import('../views/module.vue'),
    meta: {
      title: '功能分类'
    }
  },
  {
    path: '/tcmr/user',
    name: 'User',
    component: () => import('../views/User.vue'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/tcmr/history',
    name: 'History',
    component: () => import('../views/History.vue'),
    meta: {
      title: '历史账单'
    }
  },
  {
    path: '/tcmr/bindAccount',
    name: 'BindAccount',
    component: () => import('../views/bindAccount.vue'),
    meta: {
      title: '绑定户号'
    }
  },
  {
    path: '/tcmr/recharge',
    name: 'Recharge',
    component: () => import('../views/Recharge.vue')
  },
  {
    path: '/tcmr/WxRecharge',
    name: 'WxRecharge',
    component: () => import('../views/WxRecharge.vue'),
    meta: {
      title: '微信充值'
    }
  },
  {
    path: '/tcmr/accountList',
    name: 'AccountList',
    component: () => import('../views/Account.vue'),
    meta: {
      title: '我的户号'
    }
  },
  {
    path: '/tcmr/actingCapture',
    name: 'ActingCaputer',
    component: () => import('../views/ActingCapture.vue'),
    meta: {
      title: '代缴电费'
    }
  },
  {
    path: '/tcmr/paymentRecords',
    name: 'PaymentRecords',
    component: () => import('../views/paymentRecords.vue'),
    meta: {
      title: '缴费记录'
    }
  },
  {
    path: '/tcmr/bindOpenId',
    name: 'BindOpenId',
    component: () => import('../views/BindOpenId.vue'),
    meta: {
      title: '绑定账号'
    }
  },
  {
    path: '/tcmr/updatePwd',
    name: 'updatePwd',
    component: () => import('../views/updatePwd'),
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/tcmr/updatePhoneNumber',
    name: 'updatePhoneNumber',
    component: () => import('../views/updatePhoneNumber'),
    meta: {
      title: '更换手机号'
    }
  },
  {
    path: '/tcmr/forgetPwd',
    name: 'forgetPwd',
    component: () => import('../views/forgetPwd'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/tcmr/electricityHistory',
    name: 'electrictyHistory',
    component: () => import('../views/electricityHistory'),
    meta: {
      title: '用电电量'
    }
  },
  {
    path: '/tcmr/changeUserCount',
    name: 'changeUserCount',
    component: () => import('../views/changeUserCount'),
    meta:{
      title:'选择户号'
    }
  },
  {
    path: '/tcmr/post',
    name: 'post',
    component: () => import('../views/post'),
    meta:{
      title:'资讯'
    }
  },
  {
    path: '/tcmr/postDetail',
    name: 'postDetail',
    component: () => import('../views/postDetail'),
    meta:{
      title:'资讯'
    }
  },
  {
    path: '/tcmr/ycfd',
    name: 'ycfd',
    component: () => import('../views/ycfd'),
    meta:{
      title:'远程复电'
    }
  },
  {
    path: '/tcmr/payResult',
    name: 'payResult',
    component: () => import('../views/payResult'),
    meta:{
      title:'支付结果'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  console.log(to)
  const token = getToken()
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (!token && to.name !== 'Login' && to.name !== 'Home' && to.name !== 'ActingCaputer' && to.name !== 'BindOpenId') {
    console.log(to.name)
    next({
      name: 'Login'
    })
  } else {
    next()
  }
})

export default router
